import { EditEquityMarketSharePurchaseContractTemplateModalContextType } from '../types/EditEquityMarketSharePurchaseContractTemplateModalContextType';

export const editEquityMarketSharePurchaseContractTemplateModalInitValue: EditEquityMarketSharePurchaseContractTemplateModalContextType =
  {
    data: {
      societyId: '',
      documentId: null,
      contractText: '',
      isLoading: false,
      isSaving: false,
      loadError: false,
      showPreview: false,
    },
    actions: {
      handleCloseModal: () => {},
      setContractText: () => {},
      insertVariable: () => {},
      setShowPreview: () => {},
      handleSave: async () => {},
      registerTextareaRef: () => {},
    },
  };
